import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import {
  init,
  browserTracingIntegration,
  browserProfilingIntegration,
  consoleLoggingIntegration,
  replayIntegration,
} from "@sentry/react";
import reportWebVitals from "./reportWebVitals";
import worker from "./mocks/browser";
import RouterWrapper from "./RouterWrapper";

const isDevelopment = import.meta.env.MODE === "dev";
const isProduction = import.meta.env.MODE === "prod";

const shouldInitializeSentry =
  import.meta.env.VITE_SENTRY_DSN &&
  (isDevelopment || isProduction) &&
  import.meta.env.VITE_APP_ENV !== "msw-dev";

if (shouldInitializeSentry) {
  init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE || "unknown",
    release: import.meta.env.VITE_APP_VERSION,
    sendDefaultPii: isDevelopment,
    integrations: [
      browserTracingIntegration(),
      browserProfilingIntegration(),
      replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
      consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
    ],
    tracesSampleRate: isProduction ? 0.2 : 1.0,
    profilesSampleRate: isProduction ? 0.1 : 1.0,
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/development\.backend\.dashboard\.earthly\.org/,
      /^https:\/\/production\.backend\.dashboard\.earthly\.org/,
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enableLogs: true,
    ignoreErrors: [
      /Object Not Found Matching Id.*MethodName:update.*ParamCount:/,
      /Sorry, this client can't be found/,
      /Java object is gone/,
      /^invalid origin$/,
    ],
  });
}

function prepare() {
  if (import.meta.env.VITE_APP_ENV === "msw-dev") {
    return worker.start({
      onUnhandledRequest() {},
    });
  }
  return Promise.resolve();
}

prepare().then(() => {
  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement,
  );
  root.render(
    <React.StrictMode>
      <RouterWrapper />
    </React.StrictMode>,
  );
});

reportWebVitals();
